/* RAREST DIAMOND® CO. — location required before following a site link.
 * Home page is always visible without an email address or initial location prompt.
 * On the first navigational click, ask the visitor for location access.
 * Only a successful browser geolocation reading authorizes further same-tab links
 * for this browsing session. Denial, timeout or unavailability NEVER authorizes.
 * No coordinates are stored in cookies/sessionStorage or sent over the network
 * by this script. This is a consent-based UI gate, not server-side security.
 */
(function () {
  'use strict';
  var verificationKey = 'rd_location_verified_v3';
  var pendingUrl = null;
  var busy = false;
  var verifiedOnPage = false;
  var modal, allowButton, cancelButton, status;

  function readVerified() {
    if (verifiedOnPage) return true;
    try { return window.sessionStorage.getItem(verificationKey) === 'yes'; }
    catch (e) { return false; }
  }
  function recordVerified() {
    verifiedOnPage = true;
    try { window.sessionStorage.setItem(verificationKey, 'yes'); }
    catch (e) { /* Browser blocks storage: the next page will request again. */ }
  }
  function elementsReady() {
    modal = document.getElementById('rd-location-consent');
    allowButton = document.getElementById('rd-location-allow');
    cancelButton = document.getElementById('rd-location-cancel');
    status = document.getElementById('rd-location-feedback');
    return Boolean(modal && allowButton && cancelButton && status);
  }
  function showStatus(message) {
    if (status) status.textContent = message;
  }
  function openModal(url) {
    pendingUrl = url;
    modal.hidden = false;
    allowButton.disabled = false;
    showStatus('');
    document.body.classList.add('rd-location-modal-open');
    allowButton.focus();
  }
  function cancelNavigation() {
    if (busy) return;
    pendingUrl = null;
    if (modal) modal.hidden = true;
    document.body.classList.remove('rd-location-modal-open');
  }
  function onPositionSuccess(position) {
    busy = false;
    allowButton.disabled = false;
    // Geolocation success, not just click-to-consent, authorizes the link.
    if (!position || !position.coords ||
        !Number.isFinite(position.coords.latitude) ||
        !Number.isFinite(position.coords.longitude)) {
      showStatus('Location could not be verified. Check your settings and try again.');
      return;
    }
    recordVerified();
    var targetUrl = pendingUrl;
    pendingUrl = null;
    modal.hidden = true;
    document.body.classList.remove('rd-location-modal-open');
    if (targetUrl) window.location.assign(targetUrl);
  }
  function onPositionError(error) {
    busy = false;
    allowButton.disabled = false;
    if (error && error.code === 1) {
      showStatus('Location permission was denied. Allow location for this site in your browser settings, then tap Verify my location again.');
    } else if (error && error.code === 3) {
      showStatus('Location timed out. Enable your device location service and tap Verify my location again.');
    } else {
      showStatus('Location is unavailable. Enable location services and try again. Navigation is paused until verification succeeds.');
    }
    allowButton.focus();
  }
  function verifyLocation() {
    if (busy || readVerified()) return;
    if (!window.isSecureContext || !navigator.geolocation) {
      showStatus('This browser cannot access location. Please use a supported browser with location services enabled.');
      return;
    }
    busy = true;
    allowButton.disabled = true;
    showStatus('Check your browser for a location-permission request…');
    try {
      navigator.geolocation.getCurrentPosition(onPositionSuccess, onPositionError, {
        enableHighAccuracy: false,
        maximumAge: 0,
        timeout: 12000
      });
    } catch (error) {
      onPositionError(null);
    }
  }
  function handleLinkClick(event) {
    if (readVerified()) return;
    if (event.defaultPrevented || event.button !== 0 ||
        event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    var link = target && target.closest && target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.getAttribute('aria-disabled') === 'true') return;
    var href = (link.getAttribute('href') || '').trim();
    // Allow assistive skip links, browser controls and contact actions to work.
    if (!href || href === '#' || /^#(?:MainContent|main)$/i.test(href) ||
        /^(?:javascript|mailto|tel|sms|data):/i.test(href)) return;
    var url;
    try { url = new URL(link.href, window.location.href); }
    catch (e) { return; }
    if (!/^https?:$/.test(url.protocol)) return;
    // Never gate off-site links, payment processors, or in-page anchor navigation.
    // Location verification applies only when changing pages on this storefront.
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname &&
        url.search === window.location.search && url.hash) return;
    // Intercept same-tab internal shopping links (menu, product, collection, footer).
    // New-tab links retain their expected browser behavior.
    if (link.target && link.target.toLowerCase() !== '_self') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!modal.hidden) return;
    openModal(url.href);
  }
  function onModalKeyDown(event) {
    // Escape cancels navigation, but DOES NOT permit access to the linked page.
    if (event.key === 'Escape') {
      event.preventDefault();
      cancelNavigation();
      return;
    }
    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === allowButton) {
        event.preventDefault(); cancelButton.focus();
      } else if (!event.shiftKey && document.activeElement === cancelButton) {
        event.preventDefault(); allowButton.focus();
      }
    }
  }
  function initialize() {
    if (!elementsReady()) return;
    allowButton.addEventListener('click', verifyLocation);
    cancelButton.addEventListener('click', cancelNavigation);
    modal.addEventListener('keydown', onModalKeyDown);
    document.addEventListener('click', handleLinkClick, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else initialize();
}());
